import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field-scout-reports-reports-page #all_fields_table', () => {
  void import('./internal/field-scout-reports-reports-page__all_fields_table')
    .then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.field-scout-reports-reports-page', () => {
  void import('./internal/field-scout-reports-reports-page')
    .then(({ default: Component }) => Component());
});
